export const waitingMessages = {
  firstMessage: 'New instance loading...',
  secondMessage: 'Your new instance will be ready in a few moments...',
  thirdMessage:
    'Setup is taking a little longer than expected. We’ll send you an email as soon as your instance is ready.',
};
